import { z } from 'zod';

import { DeviceType } from '../../constants/auth.constants';
import { successOpenApiDescription } from '../../constants/schemas.constants';
import { type BaseSchema, requiredString, requiredUuid } from '../base.schema';
import { userSchema, userSchemaRef } from '../userSchemas/user.schema';
import { authSchema } from './auth.schema';

export const loginSchemaRef = 'LoginResponse';

export const loginResponseSchema = z
	.object({
		success: z.boolean().default(true).meta(successOpenApiDescription),
		accessToken: requiredString('schemaAttributes.accessToken').meta({
			description: 'JWT access token for authenticated user',
			example: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...',
		}),
		user: userSchema,
	})
	.strip()
	.meta({
		ref: loginSchemaRef,
		description: 'Response schema for user login.',
	});
export const loginResponseBaseSchemas: BaseSchema[] = [
	{
		name: userSchemaRef,
		schema: userSchema,
	},
];

export type LoginResponseSchemaType = z.infer<typeof loginResponseSchema>;

export const refreshTokenResponseSchemaRef = 'RefreshTokenResponse';

export const refreshTokenResponseSchema = z
	.object({
		success: z.boolean().default(true).meta(successOpenApiDescription),
		accessToken: requiredString('schemaAttributes.accessToken').meta({
			description: 'JWT access token for authenticated user',
			example: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...',
		}),
	})
	.strip()
	.meta({
		ref: refreshTokenResponseSchemaRef,
		description: 'Response schema for refreshing user access token.',
	});

export type RefreshTokenResponseSchemaType = z.infer<
	typeof refreshTokenResponseSchema
>;

export const logoutResponseSchemaRef = 'LogoutResponse';

export const logoutResponseSchema = z
	.object({
		success: z.boolean().default(true).meta(successOpenApiDescription),
	})
	.meta({
		ref: logoutResponseSchemaRef,
		description: 'Logout response schema',
	});

export type LogoutResponseSchemaType = z.infer<typeof logoutResponseSchema>;

export const getDevicesResponseSchemaRef = 'getDevicesResponse';

export const getDevicesResponseSchema = z
	.object({
		devices: z.array(authSchema).meta({
			description: 'List of user devices',
			example: [
				{
					deviceId: 'asdasdasdasdasd',
					deviceName: 'iPhone',
					deviceType: DeviceType.MOBILE,
					createdAt: '2023-10-01T12:00:00Z',
				},
			],
		}),
		deviceId: requiredUuid('schemaAttributes.deviceId').meta({
			description: 'Unique identifier for the device',
			example: '123e4567-e89b-12d3-a456-426614174000',
		}),
		success: z.boolean().default(true).meta(successOpenApiDescription),
	})
	.meta({
		description: 'Schema for getting user devices',
		ref: getDevicesResponseSchemaRef,
	})
	.strict();

export type GetDevicesResponseSchemaType = z.infer<
	typeof getDevicesResponseSchema
>;

export const logoutDeviceResponseSchemaRef = 'logoutDeviceResponse';

export const logoutDeviceResponseSchema = z
	.object({
		success: z.boolean().default(true).meta(successOpenApiDescription),
	})
	.meta({
		description: 'Schema for response of logout device',
		ref: logoutDeviceResponseSchemaRef,
	})
	.strict();

export type LogoutDeviceResponseSchemaType = z.infer<
	typeof logoutDeviceResponseSchema
>;
